import { createSlice } from "@reduxjs/toolkit"

export const creaEvento = createSlice({
    name: 'creaEvento',
    initialState: {
        value:
        {
            addobbi: false,
            attrazioniBambini: false,
            areaTavoli: false,
            artisti: '',
            biglietto: false,
            birraArtigianale: false,
            centroStorico: false,
            città: null,
            comune: '',
            dataInizio: new Date().toISOString().slice(0, 10),  
            dataFine: new Date().toISOString().slice(0, 10),          
            descrizione: "",
            djSet: false,
            emailUser: '',
            email: '',
            fb: '',
            foto: [],
            gruppo: false,
            incorporaUrl: '',
            infoOrganizzatore: '',
            indirizzo: '',
            liscio: false,
            mercatini: false,
            musica: false,
            navetta: false,
            noBiglietto: true,
            opzioniEvento: [],
            oraFine: '',
            oraInizio: '',
            ospiti: '',
            ospite1: '',
            ospite2: '',
            ospite3: '',
            ospite4: '',
            ospite5: '',
            opzioniBiglietto: '',
            provincia: '',
            pubblicitàFB: true,
            regione: '',
            parcheggio: false,   
            prezzo: '',         
            standGastronomici: false,                                                                  
            scuolaDiBallo: false,
            sito: false,         
            sottotitolo: '',
            telefono: '',
            tipologia: '',
            titolo: '',
            url: '',
            youTube: '',     
            video: null,
        }
    },
    reducers: {
        add: (state, action) => {//azione per aggiungere elemento tramite form 
            state.value.push(action.payload)
        },
        aggiorna: (state, action) => {//azione per aggiornare l'oggetto creato nel form 
            Object.assign(state.value, action.payload)//unisce il nuovo oggetto con quello creato nel form
        },
        sostituisci: (state, action) => {//update di un oggetto dalle form nell'oggetto 'cercaForDispatch'
            state.value = { ...state.value, ...action.payload }
        }
    }
})
export const { add, aggiorna, sostituisci } = creaEvento.actions
export const creaEventoReducer = creaEvento.reducer